<section *ngIf="isOnAi" class="ai_bar isOnAi" aria-label="Authorship in-depth">
  <header>
    <section class="header-section">
      <section class="header-label">
        <img src="../../../../../../assets/report_v2/authorship_border.svg" alt="" />
        <section>
          <h2 tabindex="-1" #sectionHeading>{{ "general.authorship" | translate }}</h2>
          <span aria-label="AI content score">{{ 'report_ai_authorship.ai_authorship' | translate }}</span>
        </section>
      </section>
      <button (click)="toggleIsOnAi()" aria-label="Back to Summary Analysis">
        <img src="../../../../../../assets/report_v2/arrow-right.svg" alt="" />
      </button>
    </section>
  </header>

  <!-- New Stylometrics Section -->
  <section class="foldable-container new_feature" [class.disabled]="!stylometricsEnable"
    [class.new_feature_active]="isStylometricsFolded" *ngIf="stylometricsEnable">
    <div class="fold-header new_feature" [class.active]="!isStylometricsFolded">
      <section class="fold-title">
        <section>
          <img src="../../../../../../assets/report_v2/stylometrics_logo.svg" alt="" />
          <h3>{{ 'report_ai_authorship.stylometrics' | translate }} <span class="beta-tag">BETA</span></h3>
          <app-severity *ngIf="isStylometricsFolded && stylometricsEnable"
            [severityLevel]="averageStylisticDiscrepancy?.toLowerCase()" [text]="stylometricFlagsCount + ' Flags'">
          </app-severity>
        </section>
        <p>
          {{'report_ai_authorship.stylometric_submission' | translate}}
          <a href="#" class="learn-more">{{'report_ai_authorship.learn_more' | translate}}</a>
        </p>
      </section>
      <button type="button" class="fold-toggle" (click)="toggleStylometricsFold()"
        [attr.aria-expanded]="!isStylometricsFolded"
        [attr.aria-label]="('report_ai_authorship.stylometrics' | translate)">
        <img src="../../../../../../assets/report_v2/arrow_down.svg" [class.rotated]="!isStylometricsFolded"
          alt="" aria-hidden="true" />
      </button>
    </div>

    <section class="fold-content" [class.hidden]="isStylometricsFolded">
      <app-stylometrics [previousSubmissions]="previousSubmissions" [stylometricMetrics]="stylometricMetrics"
        [metricsThresholds]="metricsThresholds" [averageStylisticDiscrepancy]="averageStylisticDiscrepancy"
        [projectSynapse]="true" [projectSynapseData]="projectSynapseData" [analysisDate]="analysisDate"
        (discrepancyLevelChange)="onProjectSynapseDiscrepancyChange($event)">
      </app-stylometrics>
    </section>
  </section>

  <!-- Project Synapse -->
  <section class="foldable-container new_feature" *ngIf="projectSynapseEnable" [class.disabled]="!projectSynapseEnable"
    [class.new_feature_active]="isProjectSynapseFolded">
    <div class="fold-header new_feature" [class.active]="!isProjectSynapseFolded">
      <section class="fold-title">
        <section>
          <img src="../../../../../../assets/report_v2/stylometrics_logo.svg" alt="" />
          <h3>{{ 'ai_advanced' | translate }} <span class="beta-tag">BETA</span></h3>
          <app-severity *ngIf="isProjectSynapseFolded && projectSynapseEnable"
            [severityLevel]="projectSynapseStylisticDiscrepancy || averageStylisticDiscrepancy?.toLowerCase()"
            [text]="(projectSynapseStylisticDiscrepancy || averageStylisticDiscrepancy) | titlecase">
          </app-severity>
        </section>
        <p>
          {{'ai_authorship.ai_generates' | translate}}
          <!-- <a href="#" class="learn-more">Learn more</a> -->
        </p>
      </section>
      <button type="button" class="fold-toggle" (click)="toggleProjectSynapseFold()"
        [attr.aria-expanded]="!isProjectSynapseFolded"
        [attr.aria-label]="('ai_advanced' | translate)">
        <img src="../../../../../../assets/report_v2/arrow_down.svg" [class.rotated]="!isProjectSynapseFolded"
          alt="" aria-hidden="true" />
      </button>
    </div>

    <section class="fold-content" [class.hidden]="isProjectSynapseFolded">
      <app-stylometrics [previousSubmissions]="previousSubmissions" [stylometricMetrics]="stylometricMetrics"
        [metricsThresholds]="metricsThresholds" [averageStylisticDiscrepancy]="averageStylisticDiscrepancy"
        [projectSynapse]="true" [projectSynapseData]="projectSynapseData" [analysisDate]="analysisDate"
        (discrepancyLevelChange)="onProjectSynapseDiscrepancyChange($event)">
      </app-stylometrics>
    </section>
  </section>


  <!-- Old AI Analysis -->
  <section class="foldable-container" [disabled]="!aiAnalysis?.checkAI" [class.disabled]="!aiAnalysis?.checkAI"
    *ngIf="simpleAIEnable">
    <div class="fold-header" [class.active]="!isAiFolded || !aiAnalysis?.checkAI">
      <section class="fold-title">
        <section>
          <img src="../../../../../../assets/report_v2/ai-authorship_borderless.svg" alt="" />
          <h3>{{ "general.ai_authorship" | translate }}</h3>
          <app-severity *ngIf="isAiFolded && aiAnalysis?.checkAI" [severityLevel]="getAiRiskLevel()"
            [text]="getAiAuthorshipLabel() | translate">
          </app-severity>
        </section>
        <p class="authorship-subtitle">
          {{ 'authorship_in_depth.authorship_examination' | translate }}
        </p>
      </section>
      <button type="button" class="fold-toggle" (click)="toggleAiFold()"
        [attr.aria-expanded]="!isAiFolded"
        [attr.aria-label]="('general.ai_authorship' | translate)"
        [disabled]="!aiAnalysis?.checkAI">
        <img src="../../../../../../assets/report_v2/arrow_down.svg" [class.rotated]="!isAiFolded"
          alt="" aria-hidden="true" />
      </button>
    </div>

    <section class="fold-content" [class.hidden]="isAiFolded || !aiAnalysis?.checkAI">
      <section class="similarity_overview">
        <h4 class="ai_similarity_percent fw-bold">
          {{ "new_entries.ai_authorship_index" | translate }}
        </h4>
        <div>
          <mat-progress-bar title="Progress Bar" id="ai" mode="determinate" [value]="aiAnalysis?.aiPercentage"
            color="#462D86"></mat-progress-bar>
          <h4 class="paragraphStyle">{{ pangramResults != null && pangramResults.fraction_ai !== undefined ? (pangramResults.fraction_ai *
            100).toFixed(1) : aiAnalysis?.aiPercentage }}%</h4>
        </div>
      </section>
      <section class="ai_score">
        <div class="alert_img">
          <img src="../../../../../../assets/report_v2/warning-circled-filled-ai.svg" alt="Alert icon" />
        </div>
        <p *ngIf="aiAnalysis?.aiPercentage >= 0 && aiAnalysis?.aiPercentage < 15" [innerHTML]="ai_percentage.low">
          {{ "new_entries.low" | translate }}
        </p>
        <p *ngIf="
            aiAnalysis?.aiPercentage >= 15 && aiAnalysis?.aiPercentage < 35
          " [innerHTML]="ai_percentage.medium">
          {{ "new_entries.medium" | translate }}
        </p>
        <p *ngIf="
            aiAnalysis?.aiPercentage >= 35 && aiAnalysis?.aiPercentage <= 100
          " [innerHTML]="ai_percentage.high">
          {{ "new_entries.high" | translate }}
        </p>
      </section>
      <section class="insights">
        <header class="insights_header margin-bottom-15">
          <img src="../../../../../../assets/report_v2/ai-insights.svg" alt="" />
          <h4>{{ "new_entries.insights" | translate }}</h4>
        </header>
        <section class="insights_section">


          <hr class="insight_divider" />

          <section class="ai_confidence_score">
            <div class="insight_row">
              <img src="../../../assets/report_v2/ai-confidence-report.svg" alt=""
                class="insight_icon" />
              <h5>{{ 'authorship_in_depth.ai_confidence_score' | translate }}</h5>
              <div class="tooltip-container">
                <button type="button" class="tooltip-trigger"
                  [attr.aria-label]="'authorship_in_depth.ai_confidence_score' | translate">
                  <img src="../../../assets/images/info.svg" alt="" class="insight_icon_second cursor_pointer" />
                </button>
                <div class="tooltip-text" role="tooltip">
                  {{ 'authorship_in_depth.ai_confidence_score_tooltip' | translate }}
                </div>
              </div>
            </div>
            <p>{{ getAIConfidenceScore() }}</p>
          </section>
          <hr class="insight_divider" />

          <section class="ai_segments">
            <div class="insight_row">
              <img src="../../../assets/report_v2/ai-segments_report.svg" alt="" class="insight_icon" />
              <h5>{{ 'authorship_in_depth.ai_segments' | translate }}</h5>
              <div class="tooltip-container">
                <button type="button" class="tooltip-trigger"
                  [attr.aria-label]="'authorship_in_depth.ai_segments' | translate">
                  <img src="../../../assets/images/info.svg" alt="" class="insight_icon_second cursor_pointer" />
                </button>
                <div class="tooltip-text" role="tooltip">
                  {{ 'authorship_in_depth.ai_segments_tooltip' | translate }}
                </div>
              </div>
            </div>
            <p>{{ getAISegmentsCount() }}</p>
          </section>
          <hr class="insight_divider" />

          <section class="ai_assisted_score">
            <div class="insight_row">
              <img src="../../../assets/report_v2/ai-assisted-report.svg" alt=""
                class="insight_icon" />
                <h5>{{ 'authorship_in_depth.ai_assisted_score' | translate }}</h5>
                <div class="tooltip-container">
                  <button type="button" class="tooltip-trigger"
                    [attr.aria-label]="'authorship_in_depth.ai_assisted_score' | translate">
                    <img src="../../../assets/images/info.svg" alt="" class="insight_icon_second cursor_pointer" />
                  </button>
                  <div class="tooltip-text" role="tooltip">
                    {{ 'authorship_in_depth.ai_assisted_score_tooltip' | translate }}
                  </div>
              </div>
            </div>
            <p>{{ getAIAssistedScore() }}</p>
          </section>
          <hr class="insight_divider" />

          <section class="human_score">
            <div class="insight_row">
              <img src="../../../assets/report_v2/human-score-report.svg" alt="" class="insight_icon" />
              <h5>{{ 'authorship_in_depth.ai_human_score' | translate }}</h5>
              <div class="tooltip-container">
                <button type="button" class="tooltip-trigger"
                  [attr.aria-label]="'authorship_in_depth.ai_human_score' | translate">
                  <img src="../../../assets/images/info.svg" alt="" class="insight_icon_second cursor_pointer" />
                </button>
                <div class="tooltip-text" role="tooltip">
                  {{ 'authorship_in_depth.ai_human_score_tooltip' | translate }}
                </div>
              </div>
            </div>
            <p>{{ getHumanScore() }}</p>
          </section>
          <hr class="insight_divider" />

          <section class="human_segments">
            <div class="insight_row">
              <img src="../../../assets/report_v2/human-segments-report.svg" alt="" class="insight_icon" />
              <h5>{{ 'authorship_in_depth.ai_human_segments' | translate }}</h5>
              <div class="tooltip-container">
                <button type="button" class="tooltip-trigger"
                  [attr.aria-label]="'authorship_in_depth.ai_human_segments' | translate">
                  <img src="../../../assets/images/info.svg" alt="" class="insight_icon_second cursor_pointer" />
                </button>
                <div class="tooltip-text" role="tooltip">
                  {{ 'authorship_in_depth.ai_human_segments_tooltip' | translate }}
                </div>
              </div>
            </div>
            <p>{{ getHumanSegmentsCount() }}</p>
          </section>

          <hr class="insight_divider" />

        </section>
      </section>
    </section>

    <div class="powered-by-pangram">
      <span>{{ 'authorship_in_depth.powered_by_pangram' | translate }}</span>
      <img src="../../../../../assets/images/pangram.png" alt="Pangram logo" class="pangram-logo">
    </div>
  </section>

  <!-- Metadata Section -->
  <section class="foldable-container" *ngIf="metadataEnable">
    <div class="fold-header" [class.active]="!isMetadataFolded">
      <section class="fold-title">
        <section>
          <img src="../../../../../../assets/report_v2/metadata_logo.svg" alt="" />
          <h3>{{ "metadata.metadata_analysis" | translate }}</h3>
          <app-severity *ngIf="isMetadataFolded" [severityLevel]="metadataIssues > 0 ? 'high' : 'low'"
            [text]="metadataIssues + ' ' + ('metadata.issues' | translate)">
          </app-severity>
        </section>
        <p>{{ "metadata.metadata_examination" | translate }}</p>
      </section>
      <button type="button" class="fold-toggle" (click)="toggleMetadataFold()"
        [attr.aria-expanded]="!isMetadataFolded"
        [attr.aria-label]="('metadata.metadata_analysis' | translate)">
        <img src="../../../../../../assets/report_v2/arrow_down.svg" [class.rotated]="!isMetadataFolded"
          alt="" aria-hidden="true" />
      </button>
    </div>

    <section class="fold-content" [class.hidden]="isMetadataFolded">
      <app-metadata [author]="author" [canEdit]="canEdit" [metadata]="metadata" [metadataUrl]="metadataUrl"
        (flagsChanged)="onFlagsChanged($event)" [anonymous]="anonymous"
        (refreshRequested)="onMetadataRefreshRequested()">
      </app-metadata>
    </section>
  </section>


</section>

<section *ngIf="!isOnAi && (simpleAIEnable || metadataEnable || stylometricsEnable || projectSynapseEnable)"
  class="ai_bar" aria-label="Authorship summary">
  <header>
    <section class="header-section">
      <section class="header-label">
        <img src="../../../../../../assets/report_v2/authorship_border.svg" alt="" />
        <section>
          <h2 tabindex="-1" #sectionHeading>{{ "general.authorship" | translate }}</h2>
          <span>{{ 'report_ai_authorship.ai_authorship' | translate }}</span>
        </section>
      </section>
      <div class="matching-responsive">
        <button (click)="toggleIsOnAi()" aria-label="Go to details of Authorship">
          <span>{{ "metadata.go_to_details" | translate }}</span>
          <img src="../../../../../../assets/report_v2/arrow-right.svg" alt="" />
        </button>
      </div>
    </section>
  </header>

  <section class="similarity_overview" *ngIf="stylometricsEnable">
    <div class="overview-head">
      <img src="../../../../../../assets/report_v2/stylometrics_logo.svg" alt="" />
      <section class="overview">
        <div>
          <span>{{'ai_authorship.stylistic_discrepancy' | translate}}</span><span class="answ">{{
            averageStylisticDiscrepancy }}</span>
        </div>
        <div>
          <span>{{'ai_authorship.flagged_metrics' | translate}}</span><span class="answ"
            [title]="'metadata_component.number_of_metrics' | translate">{{ stylometricFlagsCount
            }}</span>
        </div>
      </section>
      <div class="overview-tag stylometric">
        <p class="tag" [ngClass]="averageStylisticDiscrepancy.toLowerCase()"
          [title]="'metadata_component.metrics_exceeding' | translate"><span class="round"></span>{{
          stylometricFlagsCount }} {{'metadata_component.flags' | translate}}</p>
      </div>
      <div class="overview-arrow">
        <button (click)="navigateToStylometrics()">
          <img src="../../../../../../assets/report_v2/fast-arrow.svg" alt="Open In-Depth Authorship Analyses">
        </button>
      </div>
    </div>
  </section>
  <section class="similarity_overview" *ngIf="simpleAIEnable">
    <div class="overview-head">
      <div *ngIf="originalityDisplay !== 'None'" class="overview-tag" [ngClass]="getAiRiskLevel()">
        <h3 *ngIf="originalityDisplay === 'Percentage'" class="tag" [ngClass]="getAiRiskLevel()">
          <span class="round"></span>
          {{ pangramResults != null && pangramResults.fraction_ai !== undefined ? (pangramResults.fraction_ai * 100).toFixed(1) :
          (aiAnalysis?.aiPercentage?.toFixed(1) || '0') }}%
        </h3>

        <h3 *ngIf="originalityDisplay === 'riskFactor'" class="tag" [ngClass]="getAiRiskLevel()">
          <span class="round"></span>
          {{
          (aiAnalysis?.aiPercentage >= 35
          ? 'new_entries.high_probability'
          : aiAnalysis?.aiPercentage >= 15
          ? 'new_entries.moderate_probability'
          : 'new_entries.low_probability') | translate
          }}
        </h3>
      </div>
      <img src="../../../../../../assets/report_v2/ai-authorship_borderless.svg" alt="" />
      <section class="overview">
        <div>
          <span>{{ "general.ai_authorship" | translate }}:</span>
          <span class="answ">{{ getAiAuthorshipLabel() | translate }}</span>
        </div>
      </section>
      <div class="overview-arrow">
        <button (click)="navigateToAi()">
          <img src="../../../../../../assets/report_v2/fast-arrow.svg" alt="Open In-Depth Authorship Analyses">
        </button>
      </div>
    </div>
  </section>

  <section class="similarity_overview" *ngIf="projectSynapseEnable">
    <div class="overview-head">
      <img src="../../../../../../assets/report_v2/stylometrics_logo.svg" alt="" />
      <section class="overview">
        <div>
          <span>{{ 'ai_authorship.ai_advanced' | translate }}:</span><span class="answ">{{ getMostProbableModelStatus()
            }}</span>
        </div>
      </section>
      <div class="overview-tag stylometric">
        <p class="tag" [ngClass]="getMostProbableModelClass()"><span class="round"></span>{{
          getMostProbableModelPercentage() > 100 ? 100 : getMostProbableModelPercentage() }}%</p>
      </div>
      <div class="overview-arrow">
        <button (click)="navigateToProjectSynapse()">
          <img src="../../../../../../assets/report_v2/fast-arrow.svg" alt="Open In-Depth Authorship Analyses">
        </button>
      </div>
    </div>
  </section>

  <section class="similarity_overview" *ngIf="metadataEnable">
    <div class="overview-head">
      <div *ngIf="originalityDisplay !== 'None'" class="overview-tag" [ngClass]="metadataIssues > 0 ? 'high' : 'low'">
        <h3 class="tag" [ngClass]="metadataIssues > 0 ? 'high' : 'low'">
          <span class="round"></span>{{ metadataIssues }}
          {{ "metadata.issues" | translate }}
        </h3>
      </div>
      <img src="../../../../../../assets/report_v2/metadata_logo.svg" alt="" />
      <section class="overview">
        <div>
          <span>{{ "metadata.total_metadata" | translate }}:</span><span class="answ">{{ metadataLength }}</span>
        </div>
      </section>
      <div class="overview-arrow">
        <button (click)="navigateToMetadata()">
          <img src="../../../../../../assets/report_v2/fast-arrow.svg" alt="Open In-Depth Authorship Analyses">
        </button>
      </div>
    </div>
  </section>
</section>